import { ConfirmModal } from '@/shared/ui/components';
import { t } from 'ttag';
import type { ModalEscalatedMessageProps } from './modalEscalatedMessage.types';
import { useModalEscalatedMessage } from './useModalEscalatedMessage';

/**
 * Modal surfacing the current past-due escalation notice for the account. Reads the open flag and the selected title and message payload from useModalEscalatedMessage and renders a ConfirmModal with a single OK button that calls onClose, stacked at the supplied zIndex.
 *
 * @param zIndex - Stacking order applied to the modal.
 * @returns The rendered modal element.
 */
const ModalEscalatedMessage = ({ zIndex }: ModalEscalatedMessageProps) => {
  const { state, onClose } = useModalEscalatedMessage();

  return (
    <ConfirmModal
      isOpen={state.isOpen}
      onClickRightButton={onClose}
      rightButtonName={t`OK`}
      title={state.dataPopup?.title}
      question={state.dataPopup?.message}
      buttonRightType="outline"
      zIndex={zIndex}
    />
  );
};

export default ModalEscalatedMessage;
